import {GET_ACCOUNTS,GET_LOGS,ADD_ACCOUNTS,DEL_ACCOUNTS,UPDATE_ACCOUNT,DISABLE_ACCOUNTS,RESET_ACCOUNTS,ACCOUNT_ERROR,CLEAR_ERRORS,CLEAR_SECRETS,IN_PROGRESS,SET_STARTTIME,CLEAR_STARTTIME,FILTER_LOGS,CLEAR_LOGFILTER,FILTER_ACCOUNTS,CLEAR_ACCOUNTFILTER} from './teachTypes';

const initialState = {
  accounts: null,
  accountfiltered: null,
  logs: null,
  logfiltered: null,
  secrets: null,
  message: null,
  error: null,
  wip: false,
  startTime: null
};

export default (state=initialState, action) => {
  switch(action.type){
    case GET_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
        error: null
      };
    case GET_LOGS:
      return {
        ...state,
        logs: action.payload,
        error: null
      };
    case ADD_ACCOUNTS:
    case RESET_ACCOUNTS:
      return {
        ...state,
        secrets: action.payload,
        error: null,
        wip: false
      };
    case DEL_ACCOUNTS:
    case UPDATE_ACCOUNT:
    case DISABLE_ACCOUNTS:
      return {
        ...state,
        message: action.payload,
        error: null,
        wip: false
      };
    case IN_PROGRESS:
      return {
        ...state,
        wip: true
      };
    case ACCOUNT_ERROR:
      return {
        ...state,
        accounts: null,
        logs: null,
        message: null,
        error: action.payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        message: null,
        error: null,
        wip: false
      };
    case CLEAR_SECRETS:
      return {
        ...state,
        secrets: null
      };
    case SET_STARTTIME:
      return {
        ...state,
        startTime: Date.now()
      };
    case CLEAR_STARTTIME:
      return {
        ...state,
        startTime: null
      };
    case FILTER_LOGS:
      return {
        ...state,
        logfiltered: state.logs && state.logs.filter(v=>{
          const regex = new RegExp(`${action.payload}`,'gi');
          return v.date.match(regex) || v.action.match(regex)
        })
      };
    case CLEAR_LOGFILTER:
      return {
        ...state,
        logfiltered: null
      };
    case FILTER_ACCOUNTS:
      return {
        ...state,
        accountfiltered: state.accounts && state.accounts.filter(v=>{
          const regex = new RegExp(`${action.payload}`,'gi');
          return v.sn.match(regex) || v.loginShell.match(regex) || v.mail.match(regex) || v.gidNumber.match(regex)
        })
      };
    case CLEAR_ACCOUNTFILTER:
      return {
        ...state,
        accountfiltered: null
      };
    default:
      return {...state}
  }
};

